export enum RulDataTypeCodeEnum {
    INT = 'INT',
    STRING = 'STRING',
    TEXT = 'TEXT',
    UNITDATE = 'UNITDATE',
    UNITID = 'UNITID',
    FORMATTED_TEXT = 'FORMATTED_TEXT',
    COORDINATES = 'COORDINATES',
    RECORD_REF = 'RECORD_REF',
    DECIMAL = 'DECIMAL',
    ENUM = 'ENUM',
    FILE_REF = 'FILE_REF',
    JSON_TABLE = 'JSON_TABLE',
    STRUCTURED = 'STRUCTURED',
    DATE = 'DATE',
    URI_REF = 'URI_REF',
    BIT = 'BIT',
}
